import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import { colorSet } from '@components/Provider';
import { UFO_GRAY } from './assets';

interface ThumbnailSlideProps {
  imageUrl?: string;
  canDownload: boolean;
  handleDownloadFile: () => void;
}

const ThumbnailSlide = ({
  imageUrl,
  canDownload,
  handleDownloadFile
}: ThumbnailSlideProps) => {
  const { swiperSlideContent } = useStyles();

  if (!imageUrl) {
    return (
      <Box
        height="100%"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        minHeight={240}
      >
        <Box
          marginBottom={1}
          className="drawingFile-viewer-error"
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
        >
          <img
            width={76}
            height={68}
            src={UFO_GRAY}
            alt="UFO 이미지"
            style={{ color: colorSet.gray500 }}
          />
          <CustomizedTypography
            align="center"
            fontWeight="500"
            color="textSecondary"
            variant="body2"
          >
            해당 파일은 현재 CAPA 뷰어로 볼 수 없습니다.
          </CustomizedTypography>
        </Box>
        {canDownload && (
          <CustomizedButton variant="text">
            <CustomizedTypography
              color="primary"
              variant="body2"
              fontWeight="500"
              onClick={handleDownloadFile}
            >
              다운로드
            </CustomizedTypography>
          </CustomizedButton>
        )}
      </Box>
    );
  }

  return (
    <img className={swiperSlideContent} src={imageUrl} alt="슬라이드_이미지" />
  );
};

export default ThumbnailSlide;

const useStyles = makeStyles(() => ({
  swiperSlideContent: {
    minHeight: 240,
    width: '100%',
    height: '100%',
    position: 'absolute',
    overflow: 'hidden',
    objectFit: 'contain',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
  }
}));
